export default __webpack_public_path__ + "static/media/nansen_portfolio.886b0a77.svg";